// Import Packages
import React from 'react';

// import Helpers
import { numberToLetters } from '../../../../../../../helpers/helper';

function CellSelection({ v, dataTableValue, setDataTableValue, size }) {

    return (
        v.slice(0, size === 'medium' ? 4 : 30).map((row, rowIndex) => {
            if (size === 'medium') {
                row = row.slice(0, 2);
            }
            if (rowIndex === 0) {
                return (
                    <tr>
                        {
                            row.map((col, colIndex) =>
                                <th onClick={() => setDataTableValue(rowIndex)}>
                                    {
                                        colIndex === 0 &&
                                        <span className='tr-row-number'>
                                            {rowIndex + 1}
                                        </span>
                                    }
                                    <span className='column-letter-name'>
                                        {numberToLetters(colIndex)}
                                    </span>
                                    {col}
                                </th>
                            )
                        }
                    </tr>
                )
            }
            return (
                <tr>
                    {
                        row.map((col, colIndex) =>
                            <td onClick={() => setDataTableValue({ rowIndex, colIndex })} style={{ cursor: 'default' }}
                                className={`${dataTableValue && dataTableValue.rowIndex === rowIndex && dataTableValue.colIndex === colIndex ? 'active-col' : ''}`}
                            >
                                {
                                    colIndex === 0 &&
                                    <span className='tr-row-number'>
                                        {rowIndex + 1}
                                    </span>
                                }
                                {col}
                            </td>
                        )
                    }
                </tr>
            )
        })
    )

}


export default CellSelection;